import { Button } from "shared/ui/button";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import { useModal } from "shared/ui/modal";
import Products from "../assets/Products.png";
import styles from "./InfoBlock.module.scss";

export const InfoBlock = () => {
  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  return (
    <>
      <div className={styles.infoContainer}>
        <div className={styles.infoWrapper}>
          <p className={styles.infoWrapper__title}>
            Эффективные препараты и экспертная поддержка для вашего роста
          </p>
          <div className={styles.infoWrapper__buttonsBlock}>
            <div className={styles.infoWrapper__buttons}>
              <Button
                variant="outline"
                size="medium"
                onClick={openDisabledElementModal}
              >
                Обучение
              </Button>
              <Button
                variant="outline"
                size="medium"
                onClick={openDisabledElementModal}
              >
                Поддержка
              </Button>
              <Button
                variant="outline"
                size="medium"
                onClick={openDisabledElementModal}
              >
                Продукт
              </Button>
            </div>
            <div className={styles.infoWrapper__imgBlock}>
              <img
                src={Products}
                alt="Products"
                className={styles.infoWrapper__img}
              />
            </div>
          </div>
          <div className={styles.infoWrapper__button}>
            <Button
              variant="disabled"
              size="large"
              onClick={openDisabledElementModal}
            >
              Перейти в каталог
            </Button>
          </div>
        </div>
      </div>
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
